import React, { FC } from "react";
import { Anchor, Empty, Spin, BackTop } from "antd";
import styled from "styled-components";
import { Layout } from "../components/styled";
import Header from "../components/header";
import Footer from "../components/footer";
import Cart from "../components/cart";
import CategoryGroup from "../components/category-group";
import { CatalogCategory } from "../queries/auto-generated/schemas";
import { prettyUrlFragment } from "../helpers";
import { useSelector } from "react-redux";
import { RootState } from "../ducks";
import _ from "lodash";
import SelectedCard from "../components/location/selected-card";
import Logo from "../components/logo";
import Error from "../components/error";

const { Link } = Anchor;

const MenuPage: FC = () => {
  const {
    data: { categories },
    loading,
    error,
  } = useSelector((state: RootState) => state.catalog);

  if (error) return <Error error={error} />;

  if (loading)
    return (
      <Empty
        style={{ padding: "2em" }}
        imageStyle={{ height: "400px" }}
        image={<Logo width="400px" />}
        description={<Spin size="large" />}
      />
    );

  // Filter out categories with no items
  const activeCategories =
    _.filter(categories, (catalogItem) => {
      const items = catalogItem?.items ?? [];
      return items.length > 0;
    }) ?? [];

  const sortedCategories = activeCategories.sort((first, second) => {
    if (first.ordinal === second.ordinal) return 0;
    if (_.isNil(first.ordinal)) return 1;
    if (_.isNil(second.ordinal)) return -1;
    if (first.ordinal < second.ordinal) return -1;
    return 1;
  });

  const anchorLinks = activeCategories?.map((catalogItem, index) => (
    <Link
      key={index}
      title={catalogItem?.name}
      href={`#${prettyUrlFragment(catalogItem?.name ?? "")}`}
    />
  ));

  return (
    <Layout>
      <Header>
        <MyAnchor affix={false} offsetTop={150}>
          {anchorLinks}
        </MyAnchor>
      </Header>
      <SelectedCardContainer>
        <SelectedCard isPreview={true} />
      </SelectedCardContainer>
      <Content>
        {sortedCategories.map((category, index) => (
          <CategoryGroup
            key={index}
            catalogCategory={category as CatalogCategory}
          />
        ))}
      </Content>
      <Footer />
      <Cart />
      <BackTop />
    </Layout>
  );
};

const MyAnchor = styled(Anchor)`
  background-color: black;
  .ant-anchor {
    text-align: center;
  }
  .ant-anchor-ink {
    display: none;
  }
  .ant-anchor-link {
    display: inline-block;
    padding: 1em 1em 0;

    a {
      padding-bottom: 0.5em;
      border-bottom: 3px solid transparent;
      color: white;
    }
    &:hover a {
      border-bottom: 3px solid;
      color: #ada017;
    }
    .ant-anchor-link-title-active {
      border-bottom: 3px solid;
    }
  }
`;

const SelectedCardContainer = styled.div`
  max-width: 100%;
  padding: 1em 50px 0;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const Content = styled.main``;

export default MenuPage;
